module.exports = __webpack_public_path__ + "static/earth_elemental_myrmidon-ce16a037c902cd502ebe3f9ab11bff93.png";